export default "__VITE_ASSET__6sExP7Jd__"